import { connect } from 'react-redux';
import { reOrderTagEditor } from '../actions/tagWizardActions';
import OrderDetailManager from '../components/OrderDetailManager';
import { getMemberID, getMemberType } from '../selectors/converterSelector';

const mapStateToProps = function(store) {
    // from template
    const memberID = store.user.info.basicInfo.ID
    console.log('memberID' , store.user.info.basicInfo.ID)
    const cartStore = store
    return {
        memberType: getMemberType(store),
        memberID:memberID,
        cartStore:cartStore
    };
};
const mapDispatchToProps = function(dispatch, ownProps) {
    return {
        reOrderTagEditor: (id) => dispatch(reOrderTagEditor(id)),
    };
};
const OrderDetailManagerContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(OrderDetailManager);

export default OrderDetailManagerContainer;
